function WaiverFormPage(){
    return(
        <iframe
            src="https://remai.jdfasia.com/downloads/waiver-form.pdf"
            width="100%"
            title="Waiver Form"
            style={{height:"100vh", border:0, display:"block"}}
        ></iframe>
    );
}

export default WaiverFormPage;
